module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/winStore.1f8541bd.svg";